"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineRenameFieldsProcessor = void 0;
/**
 * The `rename_fields` processor changes field names.
 */
class ObservabilityPipelineRenameFieldsProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineRenameFieldsProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineRenameFieldsProcessor = ObservabilityPipelineRenameFieldsProcessor;
/**
 * @ignore
 */
ObservabilityPipelineRenameFieldsProcessor.attributeTypeMap = {
    fields: {
        baseName: "fields",
        type: "Array<ObservabilityPipelineRenameFieldsProcessorField>",
        required: true,
    },
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineRenameFieldsProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineRenameFieldsProcessor.js.map